const MAP_MARKER_SVG = encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none">
  <path
    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
    fill="#c92a21"
    stroke="#9e2119"
    stroke-width="1"
  />
  <circle cx="12" cy="9" r="2.5" fill="#ffffff"/>
</svg>
`);

const MAP_SELECTOR = '[data-koch-section-j-map], [data-koch-location-map]';

function parsePositions(el) {
    const raw = el.getAttribute('data-positions');
    if (!raw) {
        return [];
    }

    try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
}

function initSectionJMap(el) {
    if (!el || el.dataset.mapReady === '1' || typeof google === 'undefined' || !google.maps) {
        return false;
    }

    const positions = parsePositions(el);
    const center = positions.length > 0
        ? { lat: Number(positions[0].lat), lng: Number(positions[0].lng) }
        : { lat: 52.2799, lng: 8.0472 };

    const map = new google.maps.Map(el, {
        center,
        zoom: positions.length > 1 ? 6 : 14,
        fullscreenControl: false,
        mapTypeControl: false,
        scrollwheel: false,
        streetViewControl: false,
        styles: [
            { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
            { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
            { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
            { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
            { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
            { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
            { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
            { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] },
        ],
    });

    const infowindow = new google.maps.InfoWindow();

    positions.forEach((position) => {
        const marker = new google.maps.Marker({
            position: {
                lat: Number(position.lat),
                lng: Number(position.lng),
            },
            map,
            icon: {
                url: `data:image/svg+xml;charset=UTF-8,${MAP_MARKER_SVG}`,
                scaledSize: new google.maps.Size(30, 40),
                anchor: new google.maps.Point(15, 40),
            },
        });

        const title = position.title ? String(position.title) : '';
        const address = position.address ? String(position.address) : '';
        const content = [title, address ? `<strong>${address}</strong>` : '']
            .filter(Boolean)
            .join('<br>');

        if (content) {
            marker.addListener('click', () => {
                infowindow.setContent(content);
                infowindow.open(map, marker);
            });
        }
    });

    el.dataset.mapReady = '1';
    return true;
}

export function initSectionJMaps() {
    const nodes = document.querySelectorAll(MAP_SELECTOR);
    if (!nodes.length) {
        return;
    }

    if (typeof google === 'undefined' || !google.maps) {
        return;
    }

    nodes.forEach(initSectionJMap);
}

window.kochSectionJMapInit = initSectionJMaps;
